import { useFetch } from '../../../hooks/useFetch';
import { PageableResponseWrapper, PageQueryParams } from '../../../domain/response-wrapper';
import { Branch } from '../../../domain/branch';
import { usePagination } from '../../../hooks/usePagination';

export interface BranchFiltersQueryParams extends PageQueryParams {
  merchant_id?: string[],
  idBranch?: string[],
}

const initialFilters: BranchFiltersQueryParams = {
  page: 0,
  size: 10,
  idBranch: [],
  merchant_id: [],
};

export const useBranchFilters = () => {
  const {
    queryParams,
    setParam,
    prevPage,
    nextPage,
    search
  } = usePagination<BranchFiltersQueryParams>(initialFilters);

  const {
    data,
    loading,
    error,
  } = useFetch<PageableResponseWrapper<Branch>>('merchants-view/branches', queryParams);

  return {
    queryParams,
    results: data,
    error,
    loading,
    prevPage,
    nextPage,
    setParam,
    search
  };
};
